import { useContext } from "react";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import ProductCarousel from "@components/store/product-detail/shared/product-detail-carousel";
import SnacksDetails from "@components/store/product-detail/snacks/snacks-details";
import ProductDetailHeader from "@components/store/product-detail/shared/product-detail-header";

import { useProductInfoContext } from "@contexts/product-info-context";

import useProductDetailMultipleVariantsState from "@hooks/product-detail/use-product-details-multiple-variants-state";

import styles from "./main.module.scss";

const Snacks = ({ product, masterVariant, canBuyProduct }) => {
  const { showAddToBox, modalClasses, hidePriceDetail } = useProductInfoContext();

  const { productImgClass = "", productContentClass = "" } = modalClasses;

  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const showProductName = showAddToBox && isMobileDevice;

  const {
    optionTypeVariantMapping,
    setOptionTypeVariantMapping,
    productQuantity,
    setProductQuantity,
    selectedImageIndex,
    setSelectedImageIndex,
    variantValues,
    getDisplayPrice,
  } = useProductDetailMultipleVariantsState({ product, masterVariant });

  const sliderImages = variantValues;

  const renderProductDetailHeader = () => (
    <ProductDetailHeader
      displayPrice={!hidePriceDetail && getDisplayPrice()}
      showProductName={!showProductName}
      product={product}
    />
  );

  const renderProductDetails = () => (
    <SnacksDetails
      product={product}
      variantValues={variantValues}
      optionTypeVariantMapping={optionTypeVariantMapping}
      setOptionTypeVariantMapping={setOptionTypeVariantMapping}
      productQuantity={productQuantity}
      setProductQuantity={setProductQuantity}
      canBuyProduct={canBuyProduct}
      renderProductDetailHeader={renderProductDetailHeader}
    />
  );

  return (
    <div>
      {showProductName && <h1 className={`${styles.h1Heading} h1Heading`}>{product?.name}</h1>}
      <div data-type="product-row" className={`${styles.rowProductDetail} ${styles.rowRevamp}`}>
        {isMobileDevice && renderProductDetailHeader()}
        <div className={`${styles.productCarousalWrapper} ${productImgClass} packes-type-snack`}>
          <ProductCarousel
            sliderImages={sliderImages}
            selectedImageIndex={selectedImageIndex}
            setSelectedImageIndex={setSelectedImageIndex}
            imageMagnify
            imageCoverRequired
            carouselContainerClass={styles.withVerticalSlider}
            thumbnailContainterClass={styles.thumbBlock}
            productId={product.id}
            product={product}
          />
        </div>
        <article className={`${styles.productDetail}  ${productContentClass}`}>
          <div className={styles.productDetailBox}>{renderProductDetails()}</div>
        </article>
      </div>
    </div>
  );
};

export default Snacks;
